import { Button, Flex, IconPlus, Stack } from '@vtex/admin-ui'
import { FormState, useWatch } from '@vtex/admin-ui-form'
import { FormattedMessage } from 'react-intl'
import { LIMITS } from 'shared'
import { ZIP_CODE_RANGE_OPERATOR, ZipCodeRange } from 'typings'
import { messages } from '../messages'
import styles from '../styles'
import { Range } from './Range'

interface Props {
  name: string
  state: FormState
}

export function ZipCodeRanges(props: Props) {
  const { name, state: form } = props

  const zipCodeRanges: ZipCodeRange[] = useWatch({
    form,
    name,
  })

  function removeRange(index: number) {
    const newRanges = [...zipCodeRanges]
    newRanges.splice(index, 1)

    form.resetField(name, { defaultValue: newRanges })
  }

  function addRange() {
    const newRanges = [...zipCodeRanges]

    const lastRange: ZipCodeRange | undefined = newRanges[newRanges.length - 1]

    newRanges.push({
      from: '',
      to: '',
      operator: lastRange?.operator ?? ZIP_CODE_RANGE_OPERATOR.INCLUDE,
    })

    form.resetField(name, { defaultValue: newRanges })
  }

  return (
    <Flex className={styles.editor.list}>
      <div>
        <Stack space="$space-4" fluid>
          {zipCodeRanges.map((_, index) => (
            <Range
              key={index}
              name={`${name}.${index}`}
              onRemove={() => removeRange(index)}
              state={form}
            />
          ))}
        </Stack>

        {zipCodeRanges.length < LIMITS.MAX_ZIP_CODE_RANGES ? (
          <Button
            variant="neutralTertiary"
            icon={<IconPlus />}
            className={styles.editor.addRangeButton}
            onClick={addRange}
          >
            <FormattedMessage
              {...messages.editor.zipCodeRangeEditor.addRange}
            />
          </Button>
        ) : null}
      </div>
    </Flex>
  )
}
